<template>
    <div class="secondary-logon">
        <div class='header-wrapper'>
            <div class='container'>
                <a class='logo' href='javascript:void(0);'>
                    <img src='../../../../assets/s-logo.svg' alt='logo'>
                </a>
            </div>
        </div>
        <div class='container-wrapper'>
            <div class='content'>
                <div class='container'>
                    <div class="container-content">
                        <div class='main'>
                            <img src='../../../../assets/secondaryLogon/phone.png' width='150' height='250' alt=''>
                            <div class='otp-form'>
                                <div id='principal' class='main__mip'>
                                    <span>Hi, </span>
                                    <span>{{userInformation[0]}}</span>
                                    <span>{{userInformation[1]}}</span>
                                </div>
                                <div class='otp-title-label'>您访问的应用已启用二次认证，请通过短信验证方式登录</div>
                                <div class='otp-title-label'>请输入短信验证码：</div>
                                <div class='code-container'>
                                    <input id='code1' class='tb-code' type='text' maxlength='1'>
                                    <input id='code2' class='tb-code' type='text' maxlength='1' readonly='true'>
                                    <input id='code3' class='tb-code' type='text' maxlength='1' readonly='true'>
                                    <input id='code4' class='tb-code' type='text' maxlength='1' readonly='true'>
                                    <input id='code5' class='tb-code' type='text' maxlength='1' readonly='true'>
                                    <input id='code6' class='tb-code' type='text' maxlength='1' readonly='true'>
                                </div>
                                <div class='code-desc'>
                                    <span class='tip-error'>{{errInfo}}</span>
                                    <div class='send'>
                                        <span v-if="!isDisable" class="wait-send" @click="sendVerificationCode">{{markedWords}}</span>
                                        <span v-else class="wait-send is-disabled">{{markedWords}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class='main__btn-content'>
                                <button id='smsLogin' :class="[loginAble?'':'is-disabled']" :disable='loginAble' @click="loginVerify">登录</button>
                            </div>
                            <div class='main__desc'>
                                <span>操作提示</span>
                                <div>1、请在对应手机中查看短信验证码</div>
                                <div>2、如果您有任何疑问，请联系IT5000</div>
                            </div>
                        </div>
                        <div id='login'>
                            <form method='post' id='sms_form'>
                                <div>
                                    <input type='hidden' id='type' name='type' value='face'>
                                    <input type='hidden' id='token' name='token' size='25' value=''>
                                    <input type='hidden' id='uuid' name='uuid' size='25' value=''>
                                    <input type='hidden' id='execution' name='execution' value='e2s3'>
                                    <input type='hidden' name='_eventId' value='submit'>
                                    <input type='hidden' id='geolocation' name='geolocation'>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getVerificationCodeApi, verifyVerificationCode } from '../../api/secondaryLogon';
let countdown = 60;
export default {
    name: 'secondaryLogon',
    data() {
        return {
            userInformation: [],
            errInfo: '',
            loginAble: false,
            markedWords: '获取验证码',
            isDisable: false,
            istriggerClick: false,
            setTimeoutData: null
        };
    },
    mounted() {
        this.initInput();
    },
    methods: {
        initInput() {
            this.userInformation = localStorage.getItem('AgainVerificationPhone').split('-');
            const txts = document.querySelectorAll('.tb-code');
            let next = 0;
            let prev = 0;
            for (let i = 0; i < txts.length; i++) {
                const t = txts[i];
                t.setAttribute('readonly', true);
                t.onkeyup = (e) => {
                    const index = i;
                    if (this.getCode().length === 6) {
                        this.loginAble = true;
                        return;
                    }
                    let value = e.target.value;
                    this.errInfo = '';
                    if (isNaN(value)) {
                        txts[index].value = '';
                        return;
                    }
                    value = value.replace(/^(.).*$/, '$1');
                    next = index + 1;
                    if (next > txts.length - 1) {
                        return;
                    }
                    txts[next].removeAttribute('readonly');
                    if (value) {
                        txts[next].focus();
                    }
                };
                t.onkeydown = (e) => {
                    const index = i;
                    if (e.key === 'Backspace') {
                        let value = e.target.value;
                        this.loginAble = false;
                        prev = index - 1;
                        if (prev < 0) {
                            return;
                        }
                        txts[prev].removeAttribute('readonly');
                        if (value === '') {
                            txts[prev].value = '';
                            txts[prev].focus();
                        } else {
                            value = '';
                        }
                    }
                };
            }
            txts[0].removeAttribute('readonly');
        },
        getCode() {
            let code = '';
            const txts = document.querySelectorAll('.tb-code');
            for (let i = 0; i < txts.length; i++) {
                code = code.concat(txts[i].value);
            }
            return code;
        },
        async sendVerificationCode() {
            const codeRes = await getVerificationCodeApi();
            this.istriggerClick = true;
            if (codeRes && +codeRes.code === 0) {
                this.$message.success(codeRes.msg);
                this.getVerificationCode();
            };
        },
        getVerificationCode() {
            const that = this;
            if (countdown === 0) {
                this.isDisable = false;
                this.markedWords = '获取验证码';
                countdown = 60;
                this.istriggerClick = false;
                clearTimeout(this.setTimeoutData);
            } else {
                this.isDisable = true;
                this.markedWords = '重新发送(' + countdown + ')s';
                countdown--;
            };
            if (this.istriggerClick) {
                this.setTimeoutData = setTimeout(function () {
                    that.getVerificationCode();
                }, 1000);
            };
        },
        loginVerify() {
            const currentCode = this.getCode();
            verifyVerificationCode(currentCode).then(res => {
                if (res && +res.code === 0) {
                    this.$router.replace({ path: '/homePage' });
                };
            });
        }
    }
};
</script>
<style scoped>
@import url("./style.less");
</style>
